var exports = {
  "HM": "UserAreaSkeleton.module__userArea___Z3N5am",
  "nd": "UserAreaSkeleton.module__panel___Z3N5am",
  "zl": "UserAreaSkeleton.module__voicePanel___Z3N5am",
  "Qs": "UserAreaSkeleton.module__content___Z3N5am",
  "D_": "UserAreaSkeleton.module__identity___Z3N5am",
  "Ky": "UserAreaSkeleton.module__identityText___Z3N5am",
  "S7": "UserAreaSkeleton.module__nameRow___Z3N5am",
  "jf": "UserAreaSkeleton.module__statusRow___Z3N5am",
  "ne": "UserAreaSkeleton.module__controls___Z3N5am",
};

module.exports = exports;
